import React from "react";
import PortfolioReturns from "./section1/portfolioReturns";
import Volatility from "./section2/Volatility";
import WithCard from "../../../../common/withCard";

const Returns = ({
  portfolio_return_table_heading,
  portfolio_return_table_data,
  benchmark_name,
  model_name,
  original_riskStatistics,
  display_orig_portfolio,
  return_VS_volatility,
  typeName,
}) => {
  return (
    <div className="row">
      <PortfolioReturns
        portfolio_return_table_heading={portfolio_return_table_heading}
        portfolio_return_table_data={portfolio_return_table_data}
        benchmark_name={benchmark_name}
        model_name={model_name}
        original_riskStatistics={original_riskStatistics}
        display_orig_portfolio={display_orig_portfolio}
      />
      <div className="col-lg-5 col-md-5 col-sm-12 col-xs-12">
        <WithCard>
          <h4 className="text-uppercase bold">Return vs. VOLATILITY</h4>
          <Volatility
            return_VS_volatility={return_VS_volatility}
            typeName={typeName}
            benchmark_name={benchmark_name}
            display_orig_portfolio={display_orig_portfolio}
            model_name={model_name}
          />
        </WithCard>
      </div>
    </div>
  );
};

export default Returns;



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/performance/Returns/returns.jsx